import React from 'react';
import {Platform, Text, View} from 'react-native';

import config from '../config';

// let BUILD_INFO: any;
// if (Platform.OS !== 'android' && Platform.OS !== 'ios') {
//   BUILD_INFO = require('../../buildInfo').BUILD_INFO;
// }

const AppBuildInfoScreen = () => {
  if (Platform.OS === 'android' || Platform.OS === 'ios') {
    return null;
  }

  // const {commitHash, commitDate, appVersion, azureEnvVariables} = BUILD_INFO;
  const {commitHash, commitDate, appVersion, azureEnvVariables} = {
    commitHash: 'commitHash',
    commitDate: 'commitDate',
    appVersion: 'appVersion',
    azureEnvVariables: 'azureEnvVariables',
  };
  const envVariables = config;

  return (
    <View style={{padding: 20}}>
      <Text style={{fontSize: 20, marginBottom: 10}}>Build Information</Text>
      <Text>App Version: {appVersion}</Text>
      <Text>Commit Hash: {commitHash}</Text>
      <Text>Commit Date: {commitDate}</Text>

      <View style={{marginTop: 20}}>
        <Text style={{fontSize: 20, marginBottom: 10}}>
          Environment Variables
        </Text>
        {(Object.keys(envVariables) as Array<keyof typeof envVariables>).map(
          key => (
            <Text key={String(key)}>
              {key}: {String(envVariables[key])}
            </Text>
          ),
        )}
      </View>

      <View style={{marginTop: 20}}>
        <Text style={{fontSize: 20, marginBottom: 10}}>DevOps Variables</Text>
        {(
          Object.keys(azureEnvVariables) as Array<
            keyof typeof azureEnvVariables
          >
        ).map(key => (
          <Text key={String(key)}>
            {key}: {String(azureEnvVariables[key])}
          </Text>
        ))}
      </View>
    </View>
  );
};

export default AppBuildInfoScreen;
